import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

const URGENT_THRESHOLD_SECS = 60

const SessionCountdownTimer = ({ expiresAt }) => {
  const [secondsLeft, setSecondsLeft] = useState(null)

  useEffect(() => {
    if (!expiresAt) return

    const tick = () => {
      const remaining = Math.floor((new Date(expiresAt).getTime() - Date.now()) / 1000)
      setSecondsLeft(Math.max(0, remaining))
    }
    tick()
    const interval = setInterval(tick, 1000)
    return () => clearInterval(interval)
  }, [expiresAt])

  if (secondsLeft === null) return null

  const hours = Math.floor(secondsLeft / 3600)
  const minutes = Math.floor((secondsLeft % 3600) / 60)
  const seconds = secondsLeft % 60
  const display = hours > 0
    ? `${hours}h:${minutes}m:${seconds}s`
    : `${minutes}m:${seconds}s`

  return (
    <div style={{ color: '#939598', fontSize: '11px' }}>
      Session expires in{' '}
      <span
        style={{
          color: secondsLeft <= URGENT_THRESHOLD_SECS ? '#DD0A08' : '#F2931E',
          fontWeight: 500,
        }}
      >
        {display}
      </span>
    </div>
  )
}

SessionCountdownTimer.propTypes = {
  expiresAt: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
}

export default SessionCountdownTimer
